import React from 'react';
import { styled } from '../../styles';
import Grid from '../../Grid';
import Typography from '../../Typography';
import Box from '../../Box';
import IconButton from '../../IconButton';
import Tooltip from '../../Tooltip';
import Link from '../../Link';
import { useTheme } from '../../styles';
// Styled components
const MastheadContainer = styled(Box)(({ theme }) => ({
    height: 'auto',
    backgroundColor: theme.palette.background.paper,
    position: 'relative'
}));
const BannerContent = styled(Grid)({
    height: 32,
    width: '100%',
    position: 'relative'
});
const Content = styled(Grid, {
    shouldForwardProp: prop => prop !== 'reportingMasthead'
})(({ theme, reportingMasthead }) => ({
    display: 'flex',
    flexGrow: 1,
    padding: reportingMasthead
        ? theme.palette.space.container.default
        : `${theme.palette.space.container.dense} ${theme.palette.space.container.spacious}`
}));
const InnerContent = styled(Grid)(({ theme }) => ({
    flexWrap: 'nowrap',
    gap: theme.palette.space.container.spacious
}));
const Titles = styled(Grid)({
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    gap: '2px'
});
const PageSubtitle = styled(Typography)({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const RightContent = styled(Grid)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.palette.space.container.default
}));
const StyledLink = styled(Link)(({ theme }) => ({
    textDecoration: 'none',
    color: 'inherit',
    '&:hover': {
        textDecoration: 'none',
        backgroundColor: 'transparent'
    }
}));
const HelperIcon = ({ icon, tooltip, linkContent }) => {
    var _a, _b;
    const iconButton = (React.createElement(IconButton, { bdsSize: "input", "aria-label": tooltip || 'Helper Icon', "data-testid": "masthead-helper-icon-button" }, icon));
    if (linkContent) {
        return (React.createElement(Box, { display: "flex", alignItems: "center" },
            React.createElement(StyledLink, { href: linkContent.href, target: (_a = linkContent.target) !== null && _a !== void 0 ? _a : '_blank', rel: (_b = linkContent.rel) !== null && _b !== void 0 ? _b : 'noopener noreferrer' }, tooltip ? (React.createElement(Tooltip, { title: tooltip, placement: "top" },
                React.createElement("span", null, iconButton))) : (iconButton))));
    }
    if (tooltip) {
        return (React.createElement(Box, { display: "flex", alignItems: "center" },
            React.createElement(Tooltip, { title: tooltip, placement: "top" },
                React.createElement("span", null, iconButton))));
    }
    return (React.createElement(Box, { display: "flex", alignItems: "center", gap: 1 }, iconButton));
};
const Masthead = ({ productTitle, pageSubtitle, pageTitle, rightContent, bannerContent, reportingMasthead = false, helperIcon }) => {
    const theme = useTheme();
    return (React.createElement(MastheadContainer, { "data-testid": "masthead-container", "data-bds": "masthead" },
        bannerContent && (React.createElement(BannerContent, { item: true, "data-testid": "masthead-banner" }, bannerContent)),
        React.createElement(Content, { item: true, reportingMasthead: reportingMasthead, "data-testid": "masthead-content" },
            React.createElement(InnerContent, { container: true, direction: "row", alignItems: "center", justifyContent: "space-between", "data-testid": "masthead-inner-content" },
                React.createElement(Titles, { item: true, xs: rightContent ? 8 : 12, "data-testid": "masthead-titles" },
                    productTitle && (React.createElement(Typography, { variant: "caption", id: "masthead-product-title" }, productTitle)),
                    React.createElement(Box, { display: "flex", alignItems: "center", gap: theme.palette.space.container.dense, "data-testid": "masthead-title-row" },
                        React.createElement(Typography, { variant: "h1", component: "h1", id: "masthead-page-title" }, pageTitle),
                        helperIcon && (React.createElement(HelperIcon, { icon: helperIcon.icon, tooltip: helperIcon.tooltip, linkContent: helperIcon.linkContent }))),
                    pageSubtitle && (React.createElement(PageSubtitle, { variant: "body1", id: "masthead-page-subtitle" }, pageSubtitle))),
                rightContent && (React.createElement(RightContent, { item: true, xs: 4, "data-testid": "masthead-right-content" }, rightContent))))));
};
export default Masthead;
//# sourceMappingURL=Masthead.js.map